import { defineMessages } from 'react-intl';

const messages = defineMessages({
  dataAndPrivacyPageTitle: {
    id: 'dataAndPrivacy.page.title',
    defaultMessage: 'Data and privacy',
    description: 'Data And Privacy page title',
  },
  consentLevelTitle: {
    id: 'dataAndPrivacy.consentLevel.title',
    defaultMessage: 'Consent level',
    description: 'Data And Privacy page consent level title',
  },
  consentLevelDescription: {
    id: 'dataAndPrivacy.consentLevel.description',
    defaultMessage:
      'Please choose the Consent Level to get more personalized updates I consent that my data can be used by AGCO Corporation and its subsidiaries (together, "AGCO") for marketing, market research and advertising purposes and collected, processed and used for these purposes.',
    description: 'Data And Privacy page consent level description',
  },
  dataAndPrivacyPageAccordion1Title: {
    id: 'dataAndPrivacy.page.accordion1.title',
    defaultMessage: 'What does it mean?',
    description: 'Data And Privacy page accordion 1 title',
  },
  dataAndPrivacyPageAccordion2Title: {
    id: 'dataAndPrivacy.page.accordion2.title',
    defaultMessage: 'Your rights',
    description: 'Data And Privacy page accordion 1 title',
  },
  consentCard1Title: {
    id: 'dataAndPrivacy.consentCard.card1.title',
    defaultMessage: 'Level 1',
    description: '1st consent card title',
  },
  consentCard2Title: {
    id: 'dataAndPrivacy.consentCard.card2.title',
    defaultMessage: 'Level 2',
    description: '2nd consent card title',
  },
  consentCard3Title: {
    id: 'dataAndPrivacy.consentCard.card3.title',
    defaultMessage: 'Level 3',
    description: '3rd consent card title',
  },
  consentCard1Content: {
    id: 'dataAndPrivacy.consentCard.card1.content',
    defaultMessage: 'Communication based on your chosen marketing preferences',
    description: '1st consent card level description',
  },
  consentCard2Content: {
    id: 'dataAndPrivacy.consentCard.card2.content',
    defaultMessage: 'Personalized marketing communication based on your profile',
    description: '2nd consent card level description',
  },
  consentCard3Content: {
    id: 'dataAndPrivacy.consentCard.card3.content',
    defaultMessage: 'Enhanced online experience with your favourite brand',
    description: '3rd consent card level description',
  },
  constCardBaseMessage: {
    id: 'dataAndPrivacy.consentCard.baseMessage',
    defaultMessage: 'You will recieve:',
    description: 'Consent card base message',
  },
  marketingCommunicationPreferencesTitle: {
    id: 'dataAndPrivacy.marketingCommunicationPreferences.title',
    defaultMessage: 'Marketing Communication Preferences',
    description: 'Marketing Communication Preferences title',
  },
  marketingCommunicationPreferencesInfoText: {
    id: 'dataAndPrivacy.marketingCommunicationPreferences.infoText',
    defaultMessage: 'Provide your preferences per Brand on which you would like to receive material.',
    description: 'Marketing Communication Preferences info text',
  },
  unsubscribeFromAll: {
    id: 'dataAndPrivacy.unsubscribeFromAll',
    defaultMessage: 'Unsubscribe from all',
    description: 'Unsubscribe from all',
  },
  unsubscribeModalTitle: {
    id: 'dataAndPrivacy.unsubscribeModal.title',
    defaultMessage: 'You want to unsubscribe and opt-out?',
    description: 'Unsubscribe modal title',
  },
  unsubscribeModalDescription: {
    id: 'dataAndPrivacy.unsubscribeModal.description',
    defaultMessage: 'By opting out, all your marketing preferences & consent will be removed',
    description: 'Unsubscribe modal description',
  },
  unsubscribeModalListItem1: {
    id: 'dataAndPrivacy.unsubscribeModal.listItem.1',
    defaultMessage: 'You will no longer recieve marketing communictaion from any other AGCO affiliated brands',
    description: 'Unsubscribe modal list item 1',
  },
  unsubscribeModalListItem2: {
    id: 'dataAndPrivacy.unsubscribeModal.listItem.2',
    defaultMessage: 'AGCO will still hold your personal information.',
    description: 'Unsubscribe modal list item 2',
  },
  unsubscribeModalGdprText: {
    id: 'dataAndPrivacy.unsubscribeModal.gdprText',
    defaultMessage: 'In order to remove your personal information, please raise <mailto>GDPR request here</mailto>',
    description: 'Unsubscribe modal GDPR text',
  },
  unsubscribeModalReason: {
    id: 'dataAndPrivacy.unsubscribeModal.reason',
    defaultMessage: 'Reason',
    description: 'Reason for unsubscribing',
  },
  unsubscribeModalYourMessage: {
    id: 'dataAndPrivacy.unsubscribeModal.yourMessage',
    defaultMessage: 'Your message',
    description: 'Your message for unsubscribing',
  },
  newsletter: {
    id: 'dataAndPrivacy.newsletter',
    defaultMessage: 'Newsletter',
    description: 'Marketing communication way - Newsletter',
  },
  events: {
    id: 'dataAndPrivacy.events',
    defaultMessage: 'Events',
    description: 'Marketing communication way - Events',
  },
  offers: {
    id: 'dataAndPrivacy.offers',
    defaultMessage: 'Offers',
    description: 'Marketing communication way - Offers',
  },
  productNews: {
    id: 'dataAndPrivacy.productNews',
    defaultMessage: 'Product news',
    description: 'Marketing communication way - Product news',
  },
  surveys: {
    id: 'dataAndPrivacy.surveys',
    defaultMessage: 'Surveys',
    description: 'Marketing communication way - Surveys',
  },
  email: {
    id: 'dataAndPrivacy.email',
    defaultMessage: 'Email',
    description: 'Marketing communication channel - Email',
  },
  phone: {
    id: 'dataAndPrivacy.phone',
    defaultMessage: 'Phone',
    description: 'Marketing communication channel - Phone',
  },
  sms: {
    id: 'dataAndPrivacy.sms',
    defaultMessage: 'SMS',
    description: 'Marketing communication channel - SMS',
  },
  post: {
    id: 'dataAndPrivacy.post',
    defaultMessage: 'Post',
    description: 'Marketing communication channel - Post',
  },
});

export default messages;
